import  {baseActions}  from "./base.actions";

export const certpaymentActions = {
    add,
    edit,
    gets,
    get,
    delete: _delete,
    postbill
};

function postbill(obj,func=null) {
    
    return baseActions.post(obj,'certificationpayment','GetBillInfo/'+obj.Id,null,func)
}
function add(obj,func=null) {
    
    return baseActions.add(obj,'certificationpayment',null,func)
}

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'certificationpayment',id,null,func);
}

function gets( page, perPage, sortField, sortOrder,filter) {
    return baseActions.gets('certificationpayment', page, perPage, sortField, sortOrder,filter);
}

function get(id)
{
    return baseActions.get('certificationpayment',id);
}

function _delete(id,func=null)
{
    return baseActions.delete(id,'certificationpayment',func);
}